var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemBaths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 22.5C6.24632 22.5 6.75 21.9963 6.75 21.375C6.75 20.7537 6.24632 20.25 5.625 20.25C5.00368 20.25 4.5 20.7537 4.5 21.375C4.5 21.9963 5.00368 22.5 5.625 22.5Z",
    fill: "url(#paint0_linear_12_10468)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.875C8.87132 19.875 9.375 19.3713 9.375 18.75C9.375 18.1287 8.87132 17.625 8.25 17.625C7.62868 17.625 7.125 18.1287 7.125 18.75C7.125 19.3713 7.62868 19.875 8.25 19.875Z",
    fill: "url(#paint1_linear_12_10468)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 19.5C3.24632 19.5 3.75 18.9963 3.75 18.375C3.75 17.7537 3.24632 17.25 2.625 17.25C2.00368 17.25 1.5 17.7537 1.5 18.375C1.5 18.9963 2.00368 19.5 2.625 19.5Z",
    fill: "url(#paint2_linear_12_10468)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.875C5.87132 16.875 6.375 16.3713 6.375 15.75C6.375 15.1287 5.87132 14.625 5.25 14.625C4.62868 14.625 4.125 15.1287 4.125 15.75C4.125 16.3713 4.62868 16.875 5.25 16.875Z",
    fill: "url(#paint3_linear_12_10468)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2495 3.75H20.5588C20.4615 3.74966 20.365 3.76853 20.2749 3.80553C20.1848 3.84253 20.1029 3.89694 20.0338 3.96563L17.2495 6.75L5.18384 8.75626C5.04725 8.77886 4.91958 8.83882 4.81497 8.92952C4.71037 9.02021 4.6329 9.13809 4.59117 9.27009C4.54943 9.4021 4.54505 9.54309 4.5785 9.67743C4.61196 9.81178 4.68195 9.93424 4.78072 10.0313L13.9682 19.2188C14.0652 19.3175 14.1877 19.3875 14.322 19.421C14.4564 19.4544 14.5974 19.45 14.7294 19.4083C14.8614 19.3666 14.9793 19.2891 15.07 19.1845C15.1607 19.0799 15.2206 18.9522 15.2432 18.8156L17.2495 6.75",
    stroke: "url(#paint4_linear_12_10468)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_10468",
    x1: 1.92857,
    y1: 21.375,
    x2: 6.10714,
    y2: 21.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_10468",
    x1: 4.55357,
    y1: 18.75,
    x2: 8.73214,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_10468",
    x1: -1.07143,
    y1: 18.375,
    x2: 3.10714,
    y2: 18.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_10468",
    x1: 1.55357,
    y1: 15.75,
    x2: 5.73214,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_10468",
    x1: -16.8074,
    y1: 11.5966,
    x2: 17.9086,
    y2: 11.5966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemBaths);
export default __webpack_public_path__ + "static/media/itemBaths.434bf104d72760b5303b2c4471001bc2.svg";
export { ForwardRef as ReactComponent };